<template>
  <aside class="navbar navbar-content">
    <div v-bind:class="['navbar-show-hide', {'active': !showNavbar}]">
      <a href="javascript:;" v-on:click="showHideNavbar">
        <i class="icon-arrow"></i>
      </a>
    </div>
    <div class="navbar-logo">
      <a href="javascript:;" @click="changeLogo()">
        <img v-if="!image" src="../../assets/procon-logo.png"
             alt="Mall Logo. Click to set yours">
        <img style="height: 36px;" v-if="image" :src="UIHost + image" alt="Mall Logo">
      </a>
    </div>
    <div class="navbar-userInfo">
      <div class="user-avatar"><img src="../../assets/default-user.png" alt="User Avatar"></div>
      <div class="user-info">
        <span class="user-name">{{username}}</span>
        <span class="current-site">{{ currentSite }}</span>
        <select v-if="$store.state.malls.length > 1" v-model="mallId" v-on:change="changeMall()">
          <option v-for="mall in $store.state.malls" :key="mall.id" :value="mall.id">{{mall.name}}</option>
        </select>
        <a v-on:click="signOut" class="sign-out" href="javascript:;" v-lang.sidebar.signOut></a>
      </div>
    </div>
    <navbar/>
  </aside>
</template>

<script>
import PopupMixins from '@/components/mixins/popup.js';
import middlewareService from '@/MiddlewareService.js';
import { mallImageBus } from "@/helpers/Bus";
import NotificationsMixins from '@/components/mixins/notifications';
import { UIHost } from '@/helpers/Constants';

import Navbar from '@/components/navbar/Navbar';

export default {
  name: "sidebar",
  mixins: [PopupMixins, NotificationsMixins],
  data() {
    return {
      mallId: localStorage.mallId,
      showNavbar: true,
      UIHost,
      image: null
    };
  },
  components: {
    Navbar
  },
  computed: {
    username() {
      return (this.$store.state.username && this.$store.state.username !== '') ? this.$store.state.username : localStorage.userName;
    },
    currentSite() {
      return this.$store.state.malls?.find(x => x.id === localStorage.mallId)?.name ?? '';
    }
  },
  methods: {
    changeMall() {
      localStorage.mallId = this.mallId;
      this.$store.commit('setMallId', this.mallId);
      this.$router.push('/dashboard');
    },
    changeLogo() {
      this.$store.commit('setImage', {});
      this.$store.commit('setMallImage', true);
      this.showPopup('add-image-popup');
    },
    async uploadImage() {
      if (Object.keys(this.$store.state.image).length === 0) return;
      const image = this.$store.state.image;
      this.$store.commit('setImage', {});
      const data = await middlewareService.processRequest('/Mall/Image', 'put', {
        id: localStorage.mallId,
        iconId: image.id
      });
      if (data && data.body && data.body.success) {
        this.showSuccessUpdate({ message: 'Image Uploaded' });
        this.image = image.url;
      } else {
        this.showError();
      }
    },
    showHideNavbar() {
      this.showNavbar = !this.showNavbar;
      if (!this.showNavbar) {
        document.getElementById('app').classList.add('hide-navbar');
      } else {
        document.getElementById('app').classList.remove('hide-navbar');
      }
    },
    async signOut() {
      localStorage.removeItem('mallId');
      this.$store.commit('logout');
      this.$router.replace('/');
    }
  },
  async beforeMount() {
    if (localStorage.mallId && localStorage.mallId.length) {
      if (this.$store.state.malls.length === 0) {
        middlewareService.processRequest('/Mall').then(data => {
          if (data && data.body && data.body.success) {
            this.$store.commit('setMalls', data.body.message);
          }
        });
      }
      const data = await middlewareService.processRequest(`/Mall/Image?id=${localStorage.mallId}`);
      if (data && data.body && data.body.success) {
        const apiData = data.body.message;
        if (apiData.iconId) {
          this.image = data.body.message.icon.url;
        }
      } else {
        this.showError();
      }
    }
  },
  created() {
    mallImageBus.$on("uploadMallImage", () => this.uploadImage());
  }
};
</script>
<style scoped lang="scss">
.navbar-logo {
  img {
    margin-left: -15px;
  }
}
</style>
